/**
 * Markets-channel connect ops, shared by the SharedWorker (hydraWorker.ts)
 * and HydraClient's direct-WS path.
 *
 * The markets feed is deliberately BROAD — no sport filter. g1 used to
 * narrow it to the rendered sports (the 4-layer setSportNeeds path, removed
 * 2026-06-12): the narrowing saved steady-state parse cost but made every
 * sport-chip toggle pay a wire round trip + snapshot for data the store
 * didn't have, which read as "toggling sports is terrible" next to the
 * pre-narrowing gbuff build where a toggle is a pure local re-filter.
 * Sport-toggle latency outranks steady-state CPU here. The dashboard's
 * chip row comes from hydra's `activeSports` meta frame (HYDRA_API.md
 * §Active sports), which every markets subscribe answers with — chips
 * never depend on which market frames have been ingested.
 *
 * Hydra's `markets` channel does NOT auto-snapshot on subscribe (only
 * `orderbooks` does), so the explicit snapshot op is load-bearing for
 * backfill — without it, slow-trading tickers sit blank for minutes.
 */
export interface MarketConnectOp {
  // Index signature so the op slots straight into the worker's AnyMsg /
  // the client's Record<string, unknown> send() parameter.
  [key: string]: unknown;
  op: 'subscribe' | 'snapshot';
  channel: 'markets';
}

export function connectMarketOps(): MarketConnectOp[] {
  return [
    { op: 'subscribe', channel: 'markets' },
    { op: 'snapshot', channel: 'markets' },
  ];
}
